export const CLASS_NAMES = {
  TRIGGER: "js-drawerTrigger",
  OVERLAY: "js-overlay",
} as const;

export const BREAK_POINT = 960;
